import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TravelExploreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"travel_explore"}/>
}
